import React, { useState, useEffect } from "react";
import "../../css/Login.css";
import { useNavigate, useParams } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import PasswordInput from "../../components/global/PasswordInput";
import { getActivactionAccountByToken, activateAccount } from "../../services/users/UserService";
import { resetPassword } from "../../services/users/UserService";


const ActivationAccountPage = (type) => {
    const navigate = useNavigate();
    const { id } = useParams();

    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [error, setError] = useState("");
    const [confirmError, setConfirmError] = useState("");
    const [loading, setLoading] = useState(false);
    const [userName, setUserName] = useState("");
    const [tokenValid, setTokenValid] = useState(true);
    const [tokenError, setTokenError] = useState("");
    const [userId, setUserId] = useState(false);
    const [activationSuccess, setActivationSuccess] = useState(false);
    const componentType = type.type;

    useEffect(() => {
        if (componentType === "RESET_PASSWORD") {
            setError(false);
        } else {
            const fetchData = async () => {
                try {
                    const response = await getActivactionAccountByToken(id);

                    if (response && response.user) {
                        setUserName(response.user.username);
                        setUserId(response.user.id);
                        setTokenValid(true);
                    } else {
                        setTokenValid(false);
                        setTokenError("O link de ativação é inválido ou já foi utilizado.");
                    }
                } catch (error) {
                    setTokenValid(false);
                    setTokenError("O link expirou ou é inválido. Contacte o administrador.");
                }
            };
            fetchData();
        }

    }, [id,componentType]);


    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setConfirmError("");

        if (password !== confirmPassword) {
            setConfirmError("As palavras-passe não coincidem");
            return;
        }

        if (!password || password.length < 6) {
            setError("A palavra-passe deve ter pelo menos 6 caracteres");
            return;
        }

        setLoading(true);
        try {

            const activationAccountRequest = {
                token: id,
                userId: userId,
                password: password,
                confirmPassword: confirmPassword
            }
            if (componentType === "RESET_PASSWORD") {
                await resetPassword(activationAccountRequest);
            } else {
                await activateAccount(activationAccountRequest);
            }
            setActivationSuccess(true);
        } catch (e) {
            setError(e.message || "Erro ao ativar conta");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-container">
            <form className="login-form" onSubmit={handleSubmit} autoComplete="off">

                {!tokenValid ? (
                    <>
                        <h2 className="form-title">Erro de Ativação</h2>
                        <p style={{ color: "red", fontWeight: "bold", marginTop: "20px" }}>
                            {tokenError}
                        </p>
                        <p style={{ marginTop: "10px" }}>
                            Por favor contacte o administrador do sistema.
                        </p>
                    </>
                ) : activationSuccess ? (
                    <>
                        <h2 className="form-title">{componentType === "RESET_PASSWORD"
                                ? `Password alterada`
                                : `Conta ativada com sucesso`}
                                </h2>

                        <p style={{ color: "#04642c", fontWeight: "bold", marginTop: "20px" }}>
                            {componentType === "RESET_PASSWORD"
                                ? `A sua palavra-passe foi alterada com sucesso`
                                : `A sua conta foi ativada com sucesso.`}
                        </p>

                        <button
                            type="button"
                            style={{ marginTop: "30px" }}
                            onClick={() => navigate("/")}
                        >
                            Fazer Login
                        </button>
                    </>
                ) : (
                    <>
                        <h2 className="form-title">
                            {componentType === "RESET_PASSWORD"
                                ? `Recuperação de Password`
                                : `Bem-vindo, ${userName}`}
                        </h2>
                        {componentType !== "RESET_PASSWORD" &&
                            <h3 className="form-title">
                                Defina a sua palavra-passe
                            </h3>}

                        {error && <p className="form-error">{error}</p>}

                        {loading && (
                            <div className="loading-container">
                                <CircularProgress size={40} style={{ color: "#04642c" }} />
                            </div>
                        )}

                        <PasswordInput
                            value={password}
                            onChange={setPassword}
                            placeholder="Palavra-passe"
                            disabled={loading}
                        />

                        <PasswordInput
                            value={confirmPassword}
                            onChange={setConfirmPassword}
                            placeholder="Confirmar palavra-passe"
                            disabled={loading}
                        />

                        {confirmError && <p className="form-error">{confirmError}</p>}

                        <button type="submit" disabled={loading}>
                            {componentType === "RESET_PASSWORD"
                                ? "Recuperar Password"
                                : ` Ativar Conta`}

                        </button>
                    </>
                )}

            </form>
        </div>
    );
};


export default ActivationAccountPage;
